import{e as o,m as e}from"./chunk-HBP5N4FR.js";var f,r,t=o(()=>{e();f="https://addons.mozilla.org/en-US/firefox/addon/multiversx-defi-wallet",r="https://chrome.google.com/webstore/detail/multiversx-defi-wallet/dngmlblcodfobpdpecaadgfbcggfjfnm"});export{f as a,r as b,t as c};
//# sourceMappingURL=chunk-A2R2BMVL.js.map
